export const DRAW = 'DRAW';
export const END_DRAW = 'END_DRAW';